import React from 'react';
import './ChannelsSection.css';

const ChannelsSection = () => {
  const channels = [
    {
      id: 1,
      title: "Crypto",
      description: "Real-time insights on digital asset trends and narratives to navigate the market with confidence.",
      image: "channel_1"
    },
    {
      id: 2,
      title: "Stocks",
      description: "Actionable analysis on equities and market movements to identify opportunities and manage your portfolio effectively. ",
      image: "channel_2"
    },
    {
      id: 3,
      title: "Derivatives",
      description: "Explore max pain, options and futures to hedge risk and leverage opportunities.",
      image: "channel_3"
    },
    {
      id: 4,
      title: "News",
      description: "Curated Macro and Micro updates that give you the information you need to react quickly and stay informed.",
      image: "channel_4"
    }
  ];

  return (
    <section className="channels-section">
      <div className="channels-container">
        <div className="channels-header">
          <div className="channels-label">CHANNELS</div>
          <h2 className="channels-title">The Channels we cover</h2>
        </div>
        
        <div className="channels-grid">
          {channels.map((channel) => (
            <div key={channel.id} className="channel-card">
              <div className="channel-card-content">
                <h3 className="channel-title">{channel.title}</h3>
                <p className="channel-description">{channel.description}</p>
              </div>
              <div className="channel-image-container">
                <img 
                  src={`/assets/old/${channel.image}.png`} 
                  alt={channel.title}
                  className="channel-image"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ChannelsSection;
